import { action } from "typesafe-actions";
import { FeatureFlagsActionTypes, IFeatureFlagsState } from "./types";

export const fetchFlags = () => action(FeatureFlagsActionTypes.FETCH_FLAGS);
export const setFlags = (flags: Partial<IFeatureFlagsState> | undefined) => action(FeatureFlagsActionTypes.SET_FLAGS, flags);
